import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { firstName, lastName, email, password, repeatPassword, address1, city, zip, twitter },
} = checkout;

export function createValidationSchema(t: (key: string) => string)
{
  return [
    Yup.object().shape({
      [firstName.name]: Yup.string().required(t('Form-firstName.errorMsg')),
      [lastName.name]: Yup.string().required(t('Form-lastName.errorMsg')),
      [email.name]: Yup.string().required(t('Form-email.errorMsg')).email(t('Form-email.invalidMsg')),
      [password.name]: Yup.string().required(t('Form-password.errorMsg')).min(6, t('Form-password.invalidMsg')),
      [password.name]: Yup.string().required(t('Form-password.errorMsg')).min(6, t('Form-password.invalidMsg')),
      [repeatPassword.name]: Yup.string()
        .required(t('Form-repeatPassword.errorMsg'))
        .oneOf([Yup.ref("password"), null], t('Form-repeatPassword.invalidMsg')),
    }),
    Yup.object().shape({
      [address1.name]: Yup.string().required(t('Form-address1.errorMsg')),
      [city.name]: Yup.string().required(t('Form-city.errorMsg')),
      [zip.name]: Yup.string().required(t('Form-zip.errorMsg')).min(6, t('Form-zip.invalidMsg')),
    }),
  ];
}
